export const removeWhitespaceAndSpecialChars = (str: string) => str?.replace(/[^A-Z0-9]/gi, '')
